// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import type { State } from 'store';
import { BaseActions, WriteActions } from 'store/actionCreators';
import WriteHeader from 'components/write/WriteHeader/WriteHeader';
import type { Category, PostData } from 'store/modules/write';
import { type ContextRouter, Prompt, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Blocker from 'components/common/Blocker';
import queryString from 'query-string';
import { Helmet } from 'react-helmet';
import { escapeForUrl } from 'lib/common';
import axios from 'axios';

type Props = {
  title: string,
  body: string,
  tags: string[],
  badges: string[],
  thumbnail: ?string,
  categories: ?(Category[]),
  postData: ?PostData,
  writeExtraOpen: boolean,
  changed: boolean,
  uploadUrl: ?string,
  imagePath: ?string,
  urlSlug: ?string,
  isPrivate: boolean,
  seriesId: ?string,
} & ContextRouter;

class WriteHeaderContainer extends Component<Props> {
  timer = null;

  loadPost = (id: string) => {
    WriteActions.getPostById(id);
  };

  loadProduct = (id: string) => {
    WriteActions.getProductById(id);
  };

  loadBrand = (id: string) => {
    WriteActions.getBrandById(id);
  };

  loadBanner = (id: string) => {
    WriteActions.getBannerById(id);
  };

  loadEvent = (id: string) => {
    WriteActions.getEventById(id);
  };

  loadLetter = (id: string) => {
    WriteActions.getLetterById(id);
  };

  loadQuote = (id: string) => {
    WriteActions.getQuoteById(id);
  };

  loadPartner = (id: string) => {
    WriteActions.getPartnerById(id);
  };

  componentDidMount() {
    // if (window.ChannelIO) {
    //   setTimeout(() => {
    //     window.ChannelIO('shutdown');
    //   }, 500);
    // }
    this.timer = setInterval(this.autoTempSave, 30000);
    // reads edit_id
    const query = queryString.parse(this.props.location.search);
    if (query.edit_id && query.type === 'post') {
      this.loadPost(query.edit_id);
    } else if (query.edit_id && query.type === 'product') {
      this.loadProduct(query.edit_id);
    } else if (query.edit_id && query.type === 'brand') {
      this.loadBrand(query.edit_id);
    } else if (query.edit_id && query.type === 'banner') {
      this.loadBanner(query.edit_id);
    } else if (query.edit_id && query.type === 'event') {
      this.loadEvent(query.edit_id);
    } else if (query.edit_id && query.type === 'letter') {
      this.loadLetter(query.edit_id);
    } else if (query.edit_id && query.type === 'quote') {
      this.loadQuote(query.edit_id);
    } else if (query.edit_id && query.type === 'partner') {
      this.loadPartner(query.edit_id);
    }
  }

  componentWillUnmount() {
    // if (window.ChannelIO) {
    //   window.ChannelIO('boot', { pluginKey: '640462e2-2b19-4b18-92e4-bea6ed17cf2e' });
    // }
    if (this.timer) {
      clearInterval(this.timer);
    }
    // ListingActions.flushList();
  }

  autoTempSave = () => {
    const { postData, changed } = this.props;
    if (!postData || !changed) return;
    this.onTempSave();
  };

  onChangeTitle = e => {
    const { value } = e.target;
    WriteActions.editField({
      field: 'title',
      value,
    });
  };

  onOpenSubmitBox = () => {
    WriteActions.openSubmitBox();
  };

  onCloseSubmitBox = () => {
    WriteActions.closeSubmitBox();
  };

  onUploadClick = () => {
    const upload = document.createElement('input');
    upload.type = 'file';
    upload.onchange = e => {
      if (!upload.files) return;
      const file = upload.files[0];
      this.uploadImage(file);
    };
    upload.click();
  };

  // TODO: make this to HOC!!!!!!!!!!!!!!!!
  // may be 6 months later?
  uploadImage = async (file: any) => {
    WriteActions.setUploadMask(false);
    if (!file) return;
    if (file.size > 1024 * 1024 * 10) return;
    const fileTypeRegex = /^image\/(.*?)/;
    if (!fileTypeRegex.test(file.type)) return;
    const query = queryString.parse(this.props.location.search);
    if (!this.props.postData) {
      await WriteActions.setTempData();
      const { title, body, tags, badges, categories, thumbnail, isPrivate, seriesId } = this.props;
      const activeCategories = (() => {
        if (!categories || categories.length === 0) return [];
        return categories.filter(c => c.active).map(c => c.id);
      })();
      try {
        switch (query.type) {
          case 'post':
            await WriteActions.writePost({
              title,
              body,
              tags,
              is_temp: true,
              categories: activeCategories,
              thumbnail,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'product':
            await WriteActions.writeProduct({
              title,
              body,
              tags,
              badges,
              is_temp: true,
              categories: activeCategories,
              thumbnail,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'brand':
            await WriteActions.writeBrand({
              title,
              body,
              tags,
              is_temp: true,
              categories: activeCategories,
              thumbnail,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'banner':
            await WriteActions.writeBanner({
              title,
              body,
              tags,
              is_temp: true,
              categories: activeCategories,
              thumbnail,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'event':
            await WriteActions.writeEvent({
              title,
              body,
              tags,
              is_temp: true,
              categories: activeCategories,
              thumbnail,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'letter':
            await WriteActions.writeLetter({
              title,
              body,
              tags,
              is_temp: true,
              categories: activeCategories,
              thumbnail,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'quote':
            await WriteActions.writeQuote({
              title,
              body,
              tags,
              is_temp: true,
              categories: activeCategories,
              thumbnail,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'partner':
            await WriteActions.writePartner({
              title,
              body,
              tags,
              is_temp: true,
              categories: activeCategories,
              thumbnail,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          default:
            await WriteActions.writePost({
              title,
              body,
              tags,
              is_temp: true,
              categories: activeCategories,
              thumbnail,
              is_private: isPrivate,
              series_id: seriesId,
            });
        }
      } catch (e) {
        console.log(e);
      }
    }
    if (!this.props.postData) return;
    const { id } = this.props.postData;
    const data = new FormData();
    if (!file) return;
    const filename = escapeForUrl(file.name);
    try {
      switch (query.type) {
        case 'post':
          await WriteActions.createUploadUrl({ postId: id, filename });
          break;
        case 'product':
          await WriteActions.createProductUploadUrl({ productId: id, filename });
          break;
        case 'brand':
          await WriteActions.createBrandUploadUrl({ brandId: id, filename });
          break;
        case 'banner':
          await WriteActions.createBannerUploadUrl({ bannerId: id, filename });
          break;
        case 'event':
          await WriteActions.createEventUploadUrl({ eventId: id, filename });
          break;
        case 'letter':
          await WriteActions.createLetterUploadUrl({ letterId: id, filename });
          break;
        case 'quote':
          await WriteActions.createQuoteUploadUrl({ quoteId: id, filename });
          break;
        case 'partner':
          await WriteActions.createPartnerUploadUrl({ partnerId: id, filename });
          break;
        default:
          await WriteActions.createUploadUrl({ postId: id, filename });
      }
    } catch (e) {
      console.log(e);
    }
    try {
      WriteActions.setUploadStatus(true);
      if (!this.props.uploadUrl) return;
      await axios.put(this.props.uploadUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
        withCredentials: false,
        onUploadProgress: e => {
          if (window.nanobar) {
            window.nanobar.go((e.loaded / e.total) * 100);
          }
        },
      });
      if (!this.props.imagePath) return;
      const imageUrl = `${'\n'}![${file.name}](https://images.cacheby.com/${
        this.props.imagePath
      })${'\n'}`;
      WriteActions.setInsertText(imageUrl);
      WriteActions.setUploadStatus(false);
    } catch (e) {
      WriteActions.setUploadStatus(false);
      console.log(e);
    }
  };

  onTempSave = async () => {
    const {
      postData,
      title,
      body,
      tags,
      badges,
      categories,
      thumbnail,
      urlSlug,
      isPrivate,
      seriesId,
    } = this.props;

    const activeCategories = (() => {
      if (!categories || categories.length === 0) return [];
      return categories.filter(c => c.active).map(c => c.id);
    })();
    const query = queryString.parse(this.props.location.search);
    try {
      if (!postData) {
        switch (query.type) {
          case 'post':
            await WriteActions.writePost({
              title,
              body,
              tags,
              is_temp: true,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug || escapeForUrl(title),
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'product':
            await WriteActions.writeProduct({
              title,
              body,
              tags,
              badges,
              is_temp: true,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug || escapeForUrl(title),
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'brand':
            await WriteActions.writeBrand({
              title,
              body,
              tags,
              is_temp: true,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug || escapeForUrl(title),
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'banner':
            await WriteActions.writeBanner({
              title,
              body,
              tags,
              is_temp: true,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug || escapeForUrl(title),
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'event':
            await WriteActions.writeEvent({
              title,
              body,
              tags,
              is_temp: true,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug || escapeForUrl(title),
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'letter':
            await WriteActions.writeLetter({
              title,
              body,
              tags,
              is_temp: true,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug || escapeForUrl(title),
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'quote':
            await WriteActions.writeQuote({
              title,
              body,
              tags,
              is_temp: true,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug || escapeForUrl(title),
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'partner':
            await WriteActions.writePartner({
              title,
              body,
              tags,
              is_temp: true,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug || escapeForUrl(title),
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          default:
            await WriteActions.writePost({
              title,
              body,
              tags,
              is_temp: true,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug || escapeForUrl(title),
              is_private: isPrivate,
              series_id: seriesId,
            });
        }
      }
      if (postData && postData.is_temp) {
        switch (query.type) {
          case 'post':
            await WriteActions.updatePost({
              id: postData.id,
              title,
              body,
              tags,
              is_temp: postData.is_temp,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'product':
            await WriteActions.updateProduct({
              id: postData.id,
              title,
              body,
              tags,
              badges,
              is_temp: postData.is_temp,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'brand':
            await WriteActions.updateBrand({
              id: postData.id,
              title,
              body,
              tags,
              is_temp: postData.is_temp,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'banner':
            await WriteActions.updateBanner({
              id: postData.id,
              title,
              body,
              tags,
              is_temp: postData.is_temp,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'event':
            await WriteActions.updateEvent({
              id: postData.id,
              title,
              body,
              tags,
              is_temp: postData.is_temp,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'letter':
            await WriteActions.updateLetter({
              id: postData.id,
              title,
              body,
              tags,
              is_temp: postData.is_temp,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'quote':
            await WriteActions.updateQuote({
              id: postData.id,
              title,
              body,
              tags,
              is_temp: postData.is_temp,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          case 'partner':
            await WriteActions.updatePartner({
              id: postData.id,
              title,
              body,
              tags,
              is_temp: postData.is_temp,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug,
              is_private: isPrivate,
              series_id: seriesId,
            });
            break;
          default:
            await WriteActions.updatePost({
              id: postData.id,
              title,
              body,
              tags,
              is_temp: postData.is_temp,
              thumbnail,
              categories: activeCategories,
              url_slug: urlSlug,
              is_private: isPrivate,
              series_id: seriesId,
            });
        }
      }
      if (this.props.postData) {
        switch (query.type) {
          case 'post':
            await WriteActions.tempSave({ title, body, postId: this.props.postData.id });
            BaseActions.showToast({
              type: 'success',
              message: '포스트가 임시저장 되었습니다',
            });
            break;
          case 'product':
            await WriteActions.tempSaveProduct({ title, body, productId: this.props.postData.id });
            BaseActions.showToast({
              type: 'success',
              message: '상품이 임시저장 되었습니다',
            });
            break;
          case 'brand':
            await WriteActions.tempSaveBrand({ title, body, brandId: this.props.postData.id });
            BaseActions.showToast({
              type: 'success',
              message: '브랜드가 임시저장 되었습니다',
            });
            break;
          case 'banner':
            await WriteActions.tempSaveBanner({ title, body, bannerId: this.props.postData.id });
            BaseActions.showToast({
              type: 'success',
              message: '배너가 임시저장 되었습니다',
            });
            break;
          case 'event':
            await WriteActions.tempSaveEvent({ title, body, eventId: this.props.postData.id });
            BaseActions.showToast({
              type: 'success',
              message: '이벤트가 임시저장 되었습니다',
            });
            break;
          case 'letter':
            await WriteActions.tempSaveLetter({ title, body, letterId: this.props.postData.id });
            BaseActions.showToast({
              type: 'success',
              message: '뉴스레터가 임시저장 되었습니다',
            });
            break;
          case 'quote':
            await WriteActions.tempSaveQuote({ title, body, quoteId: this.props.postData.id });
            BaseActions.showToast({
              type: 'success',
              message: '견적요청이 임시저장 되었습니다',
            });
            break;
          case 'partner':
            await WriteActions.tempSavePartner({ title, body, partnerId: this.props.postData.id });
            BaseActions.showToast({
              type: 'success',
              message: '파트너가 임시저장 되었습니다',
            });
            break;
          default:
            await WriteActions.tempSave({ title, body, postId: this.props.postData.id });
            BaseActions.showToast({
              type: 'success',
              message: '포스트가 임시저장 되었습니다',
            });
        }
      }
    } catch (e) {
      BaseActions.showToast({
        type: 'error',
        message: '임시저장 실패',
      });
    }
  };

  onGoBack = () => {
    this.props.history.goBack();
  };

  onShowWriteExtra = () => {
    WriteActions.showWriteExtra();
  };

  onHideWriteExtra = () => {
    WriteActions.hideWriteExtra();
  };

  render() {
    const {
      onChangeTitle,
      onOpenSubmitBox,
      onCloseSubmitBox,
      onShowWriteExtra,
      onHideWriteExtra,
    } = this;
    const { title, postData, writeExtraOpen, changed, isOpen } = this.props;
    return (
      <Fragment>
        {title && (
          <Helmet>
            <title>{`(등록중) ${title} | 캐시바이`}</title>
          </Helmet>
        )}
        <WriteHeader
          onOpenSubmitBox={onOpenSubmitBox}
          onCloseSubmitBox={onCloseSubmitBox}
          onChangeTitle={onChangeTitle}
          onUploadClick={this.onUploadClick}
          onShowWriteExtra={onShowWriteExtra}
          onHideWriteExtra={onHideWriteExtra}
          title={title}
          isEdit={!!postData && !postData.is_temp}
          writeExtraOpen={writeExtraOpen}
          onGoBack={this.onGoBack}
          isOpen={isOpen}
        />
        <Prompt
          when={!!title && changed}
          message={() => '등록중이던 내용이 있습니다. 정말로 나가시겠습니까?'}
        />
        {changed && <Blocker />}
      </Fragment>
    );
  }
}

export default compose(
  withRouter,
  connect(
    ({ write }: State) => ({
      title: write.title,
      body: write.body,
      postData: write.postData,
      isOpen: write.submitBox.open,
      categories: write.submitBox.categories,
      tags: write.submitBox.tags,
      badges: write.submitBox.badges,
      writeExtraOpen: write.writeExtra.visible,
      thumbnail: write.thumbnail,
      changed: write.changed,
      uploadUrl: write.upload.uploadUrl,
      imagePath: write.upload.imagePath,
      urlSlug: write.submitBox.url_slug,
      isPrivate: write.submitBox.is_private,
      seriesId: write.submitBox.series ? write.submitBox.series.id : null,
    }),
    () => ({}),
  ),
)(WriteHeaderContainer);



// WEBPACK FOOTER //
// ./src/containers/write/WriteHeaderContainer.js